import { Component, OnInit, Input } from '@angular/core';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: '[gbc-modal-button]',
    templateUrl: './modal-button.component.html',
    styleUrls: ['./modal-button.component.scss'],
    standalone: true
})
export class ModalButtonComponent {

  @Input() buttonType: 'primary' | 'danger' | 'default' = 'default';

}
